export default {
  fieldRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    marginBottom: '16px',
    gap: '16px',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  buttons: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    justifyContent: 'flex-end',
    flex: 1,
  },
};
